import styles from './VerticalSystemModule.module.scss';

import React, { FC, useRef } from 'react';
import { VerticalSystemModule as VerticalSystem } from 'api/contentful/contentTypes.cloverdotcom';
import { TextV2 } from 'components/TextV2/TextV2';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { FlatEntry } from 'services/cms/flattenContentful';
import { AppType } from 'services/cms/typesUtil';
import { VerticalSystemAccordion } from './VerticalSystemAccordion/VerticalSystemAccordion';
import { VerticalSystemCarousel } from './VerticalSystemCarousel/VerticalSystemCarousel';
import { VerticalSystemCircle } from './VerticalSystemCircle/VerticalSystemCircle';
import { VerticalSystemContextProvider } from './VerticalSystemContext/VerticalSystemContext';
import { VerticalSystemTabs } from './VerticalSystemTabs/VerticalSystemTabs';
import { getVerticalSystemTabItems } from './getVerticalSystemTabItems';
import { useHeadingIndex } from 'hooks/useHeadingIndex';

type VerticalSystemModuleProps = AppType.Component<FlatEntry<VerticalSystem>>;

export const VerticalSystemModule: FC<VerticalSystemModuleProps> = props => {
  const { _attributes, headingIndex = 2, title } = props;
  const tabItems = getVerticalSystemTabItems(props);
  const [tagName, panelEyebrowTagName, panelTitleTagName] = useHeadingIndex(headingIndex);
  const ref = useRef<HTMLElement>(null);
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;
  const TabPanel = isDesktopOrLarge ? VerticalSystemAccordion : VerticalSystemCarousel;

  if (!title && !tabItems.length) return null;

  return (
    <VerticalSystemContextProvider initialContext={{ tabItems }}>
      <section className={styles.root} ref={ref} {..._attributes}>
        <div className={styles.header}>
          <TextV2 tagName={tagName} value={title} variant="modern-h2" className={styles.title} />
          <VerticalSystemTabs />
        </div>
        <div className={styles.main}>
          <VerticalSystemCircle />
          <TabPanel eyebrowTagName={panelEyebrowTagName} titleTagName={panelTitleTagName} />
        </div>
      </section>
    </VerticalSystemContextProvider>
  );
};
